import { keyframes, css } from 'styled-components';

export const typewriter = keyframes`
  from { width: 0 }
  to { width: 12ch }
`;

export const blink = keyframes`
  50% { border-color: transparent }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const slideUp = keyframes`
  from { transform: translateY(-10px); }
  to { transform: translateY(0); }
`;

export const scaleEffect = keyframes`
  from {
    transform: scale(0.8);
  }
  to {
    transform: scale(1);
  }
`;

export const slideUnderline = keyframes`
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
`;

export const slideInFromLeft = keyframes`
  from {
    transform: translateX(-20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const slideInFromRight = keyframes`
  from {
    transform: translateX(20px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const zoomIn = keyframes`
  from {
    transform: scale(0.5);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const bounceIn = keyframes`
  0% {
    transform: scale(0.3);
    opacity: 0;
  }
  50% {
    transform: scale(1.05);
    opacity: 0.9;
  }
  70% { 
    transform: scale(0.9); 
  }
  100% { 
    transform: scale(1);
    opacity: 1;
  }
`;

export const pulseIn = keyframes`
  0% {
    transform: scale(0.95);
    opacity: 0;
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

/**
 * CSS utility for handling animations with reduced motion accessibility
 * Apply this to any element with animations to ensure proper accessibility handling
 */
export const accessibleAnimationStyles = css`
  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    animation: none;
    transform: none;
    transition: none;
  }
`;
